<template>
  <div v-show="modelValue" class="modal-overlay" @click.self="close">
    <div class="modal-window">
      <header class="modal-header">
        <h3>Сменить логотип</h3>
        <button class="close-btn" @click="close">✕</button>
      </header>

      <section class="modal-body">
        <div class="upload-column">
          <Upload
          	:accept-types="['.svg','image/svg+xml']"
            :initialFiles="initialFiles"
            @selected-files="onSelectedFiles"
          />
        </div>

        <aside class="preview-column">
          <div class="preview-box">
            <p v-if="!chosenUrl">Нет выбранного изображения</p>
            <img v-else :src="chosenUrl" alt="preview" />
          </div>
          <div class="preview-info" v-if="chosenName">
            <div class="name">{{ chosenName }}</div>
            <small class="hint">Выбранный файл (будет использован как ссылка)</small>
          </div>
        </aside>
      </section>

      <footer class="modal-footer">
        <button class="btn secondary" @click="close">Отмена</button>
        <button
          class="btn primary"
          :disabled="!chosenUrl"
          @click="save"
        >
          Сохранить
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import Upload from "@/components/UI/Upload/Upload.vue";

export default {
  name: 'ChangeLogoModal',
  components: { Upload },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    initialFiles: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'logo-changed'],
  data () {
    return {
      selectedFiles: [] // массив объектов { name, url, selected }
    }
  },
  computed: {
    // выбранный объект (radio-like). Если нет явно выбранного — берём последний.
    chosen () {
      if (!this.selectedFiles || !this.selectedFiles.length) return null;
      const sel = this.selectedFiles.find(f => f.selected);
      return sel || this.selectedFiles[this.selectedFiles.length - 1] || null;
    },
    chosenUrl () {
      return this.chosen?.url || null;
    },
    chosenName () {
      return this.chosen?.name || null;
    }
  },
  methods: {
    onSelectedFiles(files) {
      // Upload.emit('selected-files', fileData) — у тебя так и есть
      this.selectedFiles = files || [];
    },
    save() {
      if (!this.chosenUrl) return;
      // возвращаем url обратно в Navbar
      this.$emit('logo-changed', this.chosenUrl);
      this.$emit('update:modelValue', false);
    },
    close() {
      this.$emit('update:modelValue', false);
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}
.modal-window {
  width: min(920px, 100%);
  background: var(--grey-1);
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid rgba(255,255,255,0.03);
}
.close-btn {
  background: transparent;
  border: none;
  font-size: 1.1rem;
  cursor: pointer;
  filter:invert(1)
}
.close-btn:hover {
	opacity: 0.5
}
.modal-body {
  display: flex;
  gap: 1rem;
  padding: 1rem;
}
.upload-column {
  flex: 1 1 60%;
}
.preview-column {
  width: 240px;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: center;
}
.preview-box {
  width: 200px;
  height: 120px;
  border-radius: 8px;
  background: var(--grey-0);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.preview-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-top: 1px solid rgba(255,255,255,0.03);
}
.btn {
  padding: 0.5rem 0.9rem;
  border-radius: 0.5rem;
  cursor: pointer;
  font-weight: 600;
  border: none;
  color: var(--color-0);
}
.btn.primary {
  background: var(--blue-0);
}
.btn.secondary {
  background: var(--grey-1);
}
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.preview-info .name {
  font-weight: 600;
  text-align: center;
  word-break: break-all;
}
.hint {
  color: var(--grey-0);
  font-size: 0.8rem;
  text-align: center;
}
</style>
